import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailEanvBgsUns extends GuiDetailGeneric {

    constructor() {
        super("EanvBgsUns");
    }

}
